import React from "react";
import "../report-styles/searchBar.scss";
import SearchIcon from "../svgs/Search Duo.svg";

const SearchBar = ({ value, onChange }) => {
  return (
    <div className="search-bar-select">
      <img src={SearchIcon} alt="Search" />
      <input
        type="text"
        placeholder="Search"
        value={value}
        onChange={(e) => onChange(e)}
      />
    </div>
  );
};

export default SearchBar;
